import { Base, BaseDTO } from "./base";
import { AbstractControl } from "@angular/forms";

export interface TimeSlotsFilters{
    search?: string;
    active?: number;
    tenant_id?: number;
    onlyCurrentTenant?: boolean;

}

export interface TimeSlotsDTO extends BaseDTO{
    start_time: string;
    end_time: string;
    day_of_week: number;
    active: number;
    tenant_id: number;
}

export class TimeSlots extends Base{
    start_time: string;
    end_time: string;
    day_of_week: number;
    active: boolean;
    tenant_id: number;



    constructor(source: TimeSlotsDTO){
        super(source);
        if(source){
            this.start_time = source.start_time;
            this.end_time = source.end_time;
            this.day_of_week = source.day_of_week;
            this.active = source.active === 1 ? true : false;
            this.tenant_id = source.tenant_id; 
        }
    }

    toDTO(): TimeSlotsDTO{
        let result: TimeSlotsDTO = <TimeSlotsDTO>super.toDTO();
        result.start_time = this.start_time;
        result.end_time = this.end_time;
        result.day_of_week = this.day_of_week;
        result.active = this.active ? 1 : 0,
        result.tenant_id = this.tenant_id;

        return result;
    }

    static fromFormGroup(formGroup: AbstractControl, original?: TimeSlots){
        const formModel = formGroup.value;
        let timeslots: TimeSlots = new TimeSlots(null);
        timeslots.start_time = formModel.start_time;
        timeslots.end_time = formModel.end_time;
        timeslots.day_of_week = formModel.day_of_week;
        timeslots.active = formModel.active;
        timeslots.tenant_id = formModel.tenant_id;

        if (original) {
            timeslots.id = original.id;
        }
        return timeslots;
    }
}